import { render, staticRenderFns } from "./ExportResourceDialog.vue?vue&type=template&id=c2ebd672&scoped=true&"
import script from "./ExportResourceDialog.vue?vue&type=script&lang=js&"
export * from "./ExportResourceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExportResourceDialog.vue?vue&type=style&index=0&id=c2ebd672&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ebd672",
  null
  
)

export default component.exports